import React from 'react';
import {
  getPaymentMethodDisplayFields,
  getPaymentMethodQrUrl,
  type PaymentMethodDisplayField,
} from '../../utils/paymentMethodMedia';

export function PaymentMethodFieldValue({
  field,
  className = '',
}: {
  field: PaymentMethodDisplayField;
  className?: string;
}) {
  if (field.href) {
    return (
      <a
        href={field.href}
        target="_blank"
        rel="noopener noreferrer"
        className={`text-[#1A56DB] underline break-all ${className}`.trim()}
      >
        {field.value}
      </a>
    );
  }
  return <span className={`break-all select-all ${className}`.trim()}>{field.value}</span>;
}

/** Labeled payment details + QR so the client can copy data or scan. */
export function PaymentMethodMedia({
  accountInfo,
  compact = false,
}: {
  accountInfo?: Record<string, unknown> | null;
  compact?: boolean;
}) {
  const fields = getPaymentMethodDisplayFields(accountInfo);
  const qr = getPaymentMethodQrUrl(accountInfo);
  if (fields.length === 0 && !qr) return null;

  const imgMax = compact ? 'max-h-28' : 'max-h-40';

  return (
    <div className="mt-2 space-y-2">
      {fields.length > 0 ? (
        <dl className="space-y-1 text-sm text-gray-700">
          {fields.map((f) => (
            <div key={`${f.label}-${f.value}`} className="flex justify-between gap-3">
              <dt className="shrink-0 text-gray-500">{f.label}</dt>
              <dd className="text-right font-medium text-gray-900">
                <PaymentMethodFieldValue field={f} />
              </dd>
            </div>
          ))}
        </dl>
      ) : null}
      {qr ? (
        <div>
          <p className="text-xs text-gray-500 mb-1">Código QR — escanéalo para pagar</p>
          <img
            src={qr}
            alt="Código QR de pago"
            className={`${imgMax} w-auto rounded border border-gray-200 bg-white p-2`}
          />
        </div>
      ) : null}
    </div>
  );
}
